import moment from 'moment';
import { IShippingSearchDownload } from './i-shipping-search-download';

export class ShippingSearchDownload {
  downloadId: number;
  runDateTime: Date;
  status: string;
  downloadName: string;
  documentId: string;
  downloadSize: number;
  userId: number;

  constructor(downloadData: IShippingSearchDownload) {
    this.downloadId = downloadData.downloadId;
    this.runDateTime = new Date(downloadData.runDateTime);
    this.status = downloadData.status.toLowerCase();
    this.downloadName = downloadData.downloadName;
    this.documentId = downloadData.documentId;
    this.downloadSize = downloadData.downloadSize;
    this.userId = downloadData.userId;
  }

  get formattedRunDateTime(): string {
    return moment(this.runDateTime).format('MM/DD/YYYY h:mm A');
  }

  get statusIcon(): string {
    if (this.status === 'failed') {
      return 'text-bg-danger';
    }
    if (this.status === 'pending') {
      return 'text-bg-warning';
    }
    if (this.status === 'new') {
      return 'text-bg-info';
    }
    if (this.status === 'exists') {
      return 'd-none';
    }
    return '';
  }
}
